import QuickService from './src/QuickService.vue'
import Process from './src/Process.vue'
import Qa from './src/Qa.vue'
import Links from './src/Links.vue'
import Policy from './src/Policy.vue'
// import Course from './src/Course.vue'
import CourseOffline from './src/CourseOffline.vue'
import CoursePrivate from './src/CoursePrivate.vue'
import CourserBox from './src/CourserBox.vue'
import Banner from './src/Banner.vue'

export default {
    QuickService,
    Process,
    Qa,
    Links,
    Policy,
    // Course,
    CourseOffline,
    CoursePrivate,
    CourserBox,
    Banner
}


// WEBPACK FOOTER //
// ./src/components/Home3.0/index.js